import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Admin.css";

const Scheduler = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);
  const userName = sessionStorage.getItem("username");
  const userType = sessionStorage.getItem("userType"); 
  const userId = sessionStorage.getItem("userId"); 
  const userImage = "https://broken-link.com/avatar.png";

  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [tutors, setTutors] = useState([]);
  const [students, setStudents] = useState([]);
  const [scheduledClasses, setScheduledClasses] = useState([]);
  const [selectedTutor, setSelectedTutor] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [repeatWeekly, setRepeatWeekly] = useState(false);
  const [recurringWeeks, setRecurringWeeks] = useState(1);
  const [istClock, setIstClock] = useState("");
  // Inline edit states
  const [editConflictMessage, setEditConflictMessage] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    day: "",
    start: "",
    end: "",
    classDate: null,
    rescheduleDate: null
  });

  const weekdays = [
    "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
  ];

  const fetchUsers = async () => {
    try {
      //const res = await axios.get("http://localhost:8000/api/users");
      const res = await axios.get("https://alphabeta4success.com/api/users");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch scheduled classes only if Student , Tutor , Day are selected
  const fetchScheduledClasses = async () => {
    
    if (!selectedStudent && !selectedTutor && !selectedDay) {
      alert("Please select at least one filter to get scheduled class details");
      return;
    }
    setScheduledClasses([]); 
    try {
      //const res = await axios.get("http://localhost:8000/api/scheduled", {
      const res = await axios.get("https://alphabeta4success.com/api/scheduled", {
        params: {
          student: selectedStudent,
          tutor: selectedTutor,
          day: selectedDay,
          role: userType,
          ID: userId
        }
      });

      const classes = res.data.data || res.data || [];

      // Mark conflicts
      const updatedClasses = classes.map(cls => {
        const conflict = classes.some(
          c =>
            c.ID !== cls.ID &&
            cls.Start_time < c.End_time &&
            cls.End_time > c.Start_time &&
            (c.Tutor_ID === cls.Tutor_ID || c.Student_ID === cls.Student_ID)
        );
        return { ...cls, conflict };
      });

      setScheduledClasses(updatedClasses);
    } catch (err) {
      console.error(err);
    }
  };

  const searchUsers = async () => {
    if (searchQuery.trim() === "") {
      fetchUsers();
      return;
    }
    try {
      //const res = await axios.get(`http://localhost:8000/api/search/${searchQuery}`);
      const res = await axios.get(`https://alphabeta4success.com/api/search/${searchQuery}`);
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();

    const fetchTutors = async () => {
      try {
        //const res = await axios.get("http://localhost:8000/api/tutors");
        const res = await axios.get("https://alphabeta4success.com/api/tutors");
    
        let tutors = Array.isArray(res.data)
          ? res.data
          : res.data?.data || [];
    
        // 🔐 role-based filtering
        if (userType === "Tutor") {
          tutors = tutors.filter(t => t.UserID === userId);
        }
    
        setTutors(tutors);
      } catch (err) {
        console.error("Error fetching tutors:", err);
        setTutors([]);
      }
    };

    const fetchStudents = async () => {
      try {
        //const res = await axios.get("http://localhost:8000/api/students");
        const res = await axios.get("https://alphabeta4success.com/api/students");
        setStudents(res.data);
      } catch (err) {
        console.error("Error fetching students:", err);
      }
    };

    const fetch_Tutors_Students = async () => {
      try {
        //const res = await axios.get("http://localhost:8000/api/tutors-students",
        const res = await axios.get("https://alphabeta4success.com/api/tutors-students",
          {
            params: {
              tutor_id: userId
            }
          }
        );
    
        setStudents(res.data || []);
      } catch (err) {
        console.error("Error fetching students:", err);
        setStudents([]);
      }
    };

    fetchTutors();

    if (userType === "Tutor") {
      fetch_Tutors_Students();
    }
    else{
      fetchStudents();
    }

    const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);

    return () => {
      clearInterval(clockInterval);
    };
  }, [userId, userType]);

  const hasConflictForReschedule = (day, start, end, tutorId, studentId, excludeId) => {
    return scheduledClasses.some(cls => {
      if (cls.ID === excludeId) return false; // skip current class
      if (cls.Day !== day) return false;
      return (
        (cls.Tutor_ID === tutorId || cls.Student_ID === studentId) &&
        start < cls.End_time &&
        end > cls.Start_time
      );
    });
  };

  const handleSaveEdit = async (cls) => {
    const { day, start, end, classDate, rescheduleDate} = editForm;

    const conflict = hasConflictForReschedule(
      day,
      start,
      end,
      cls.Tutor_ID,
      cls.Student_ID,
      cls.ID
    );

    if (conflict) {
      setEditConflictMessage(
        "Conflict detected: Either tutor or student already has a class!"
      );
      return;
    }

    try {
      //await axios.put(`http://localhost:8000/api/reschedule/${cls.ID}`, {
      await axios.put(`https://alphabeta4success.com/api/reschedule/${cls.ID}`, {
        day,
        stime: start,
        etime: end,
        classDate: formatDateTimeForSQL(editForm.classDate),
        rescheduleDate: formatDateTimeForSQL(editForm.rescheduleDate),
      });
      fetchScheduledClasses();
      setEditingId(null);
      setEditConflictMessage("");
      resetForm();
    } catch (err) {
      console.error(err);
      setEditConflictMessage("Failed to update schedule. Try again.");
      // Check for conflict response from backend
      if (err.response && err.response.status === 409 && err.response.data.type === "conflict") {
        const conflictMessages = err.response.data.details.join("\n");
        alert(`Schedule conflict detected:\n${conflictMessages}`);
      } else {
        alert("Failed to save schedule.");
      }
    }
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
  
    // expected format: dd/MM/yyyy
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    const [day, month, year] = parts;
    const d = new Date(Number(year), Number(month) - 1, Number(day));
    return isNaN(d.getTime()) ? null : d;
  };

  const formatDateTimeForSQL = (date) => {
    if (!date) return null;
  
    const d = new Date(date);
  
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
  
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const resetForm = () => {
    setSelectedTutor('');
    setSelectedStudent('');
    setSelectedSubject('');
    setSelectedGrade('');
    setSelectedDay('');
    setStartTime('');
    setEndTime('');
    setEditForm({
      day: "",
      start: "",
      end: "",
      classDate: null,
      rescheduleDate: null
    });
    setRepeatWeekly(false);
    setRecurringWeeks(1);
  };

  const handleRemove = async (id) => {
    try {
      //alert(id);
      //await axios.delete(`http://localhost:8000/api/dschedule/${id}`);
      await axios.delete(`https://alphabeta4success.com/api/dschedule/${id}`);
      setScheduledClasses(scheduledClasses.filter(cls => cls.ID !== id));
    } catch (err) {
      console.error("Error removing class:", err);
    }
  };

  return (
    <div>
      <section id="sidebar">
        <Link to="#" className="brand">
          <img src="/Assets/images/AB4S_logo.png" alt="AB4S" className="sidebar-logo" />
        </Link>
        {userType === "Admin" && (
        <> 
        <ul className="side-menu top">
          <li><Link to="/AdminDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
          <li><a href="https://alphabeta4success.com/action.html" target="_blank" rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
          <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
          <li><Link to="/Allocation"><i className="bx bxs-book-content"></i><span className="text">Allocation</span></Link></li>
          <li className="active"><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
          <li><Link to="/UserManagement"><i className="bx bxs-group"></i><span className="text">User Management</span></Link></li>
          <li><Link to="/Contacts"><i className="bx bx-id-card"></i><span className="text">Contacts</span></Link></li>
          <li><Link to="/Reports"><i className="bx bx-download"></i><span className="text">Reports</span></Link></li>
          <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
          <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
        </ul>
        <ul className="side-menu">
          <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
          <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
        </ul>
        </>
        )}

        {userType === "Tutor" && (
        <> 
          <ul className="side-menu top">
            <li><Link to="/TutorDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
            <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
            <li className="active"><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
            <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
            <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
           </ul>
           <ul className="side-menu">
            <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
            <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
           </ul>
        </>
        )}
      </section>

      <section id="content">
        <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          <form onSubmit={(e) => { e.preventDefault(); searchUsers(); }}>
            <div className="form-input">
              <input type="search" placeholder="Search by username..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
              <button type="submit" className="search-btn" onClick={searchUsers}>
                <i className="bx bx-search"></i>
              </button>
            </div>
          </form>
          <input type="checkbox" id="switch-mode" hidden />
          <label htmlFor="switch-mode" className="switch-mode"></label>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>

        <main>
          <div className="head-title">
            <h2>Re-Schedule a Class</h2>
          </div>
          <table>
            <tbody>
                <tr>
                    <td>
                    <div className="allocation-form p-4 max-w-2xl mx-auto">
                        <table>
                        <tbody>
                            <tr>
                            <td>
                                <select value={selectedStudent} onChange={e => setSelectedStudent(e.target.value)}>
                                <option value="">-- Select Student --</option>
                                {students.map(s => <option key={s.UserID} value={s.UserID}>{s.FullName}</option>)}
                                </select>
                            </td>
                            <td>
                                <select value={selectedTutor} onChange={e => setSelectedTutor(e.target.value)}>
                                <option value="">-- Select Tutor --</option>
                                {tutors.map(t => <option key={t.UserID} value={t.UserID}>{t.FullName}</option>)}
                                </select>
                            </td>
                            <td>
                                <select value={selectedDay} onChange={e => setSelectedDay(e.target.value)}>
                                <option value="">-- Select Day --</option>
                                {weekdays.map(day => <option key={day} value={day}>{day}</option>)}
                                </select>
                            </td>
                            <td>
                                <button onClick={fetchScheduledClasses} className="bg-blue-500 text-white p-2 rounded w-full">Submit</button>
                            </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>

                    <div className="allocation-form p-4">
                        <h3 className="highlight-red">Scheduled Class lists</h3>
                        {scheduledClasses.length > 0 ? (
                        <table className="w-full mt-2 border-collapse border border-gray-300">
                            <thead>
                            <tr className="bg-gray-200">
                                <th className="border px-4 py-2">Student</th>
                                <th className="border px-4 py-2">Tutor</th>
                                <th className="border px-4 py-2">Date</th>
                                <th className="border px-4 py-2">Day</th>
                                <th className="border px-4 py-2">Start</th>
                                <th className="border px-4 py-2">End</th>
                                <th className="border px-4 py-2">Reschedule Date</th>
                                <th className="border px-4 py-2">Status</th>
                                <th className="border px-4 py-2">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {scheduledClasses.map(cls => (
                                <tr key={cls.ID}>
                                <td>{cls.Student}</td>
                                <td>{cls.Tutor}</td>
                                {/* CLASS DATE */}
                                <td>
                                  {editingId === cls.ID ? (
                                    <DatePicker withPortal
                                      selected={editForm.classDate}
                                      onChange={(date) =>
                                        setEditForm(prev => ({ ...prev, classDate: date }))
                                      }
                                      dateFormat="dd/MM/yyyy"
                                      popperPlacement="bottom-start"
                                    />
                                  ) : (
                                    cls.ClassDate
                                  )}
                                </td>
                                <td>
                                  {editingId === cls.ID ? (
                                    <select
                                      value={editForm.day}
                                      onChange={(e) =>
                                        setEditForm(prev => ({ ...prev, day: e.target.value }))
                                      }
                                    >
                                      {weekdays.map(d => (
                                        <option key={d} value={d}>{d}</option>
                                      ))}
                                    </select>
                                  ) : (
                                    cls.Day
                                  )}
                                </td>
                                <td>
                                  {editingId === cls.ID ? (
                                    <input
                                      type="time"
                                      value={editForm.start}
                                      onChange={(e) =>
                                        setEditForm(prev => ({ ...prev, start: e.target.value }))
                                      }
                                    />
                                  ) : (
                                    cls.Start_time
                                  )}
                                </td>
                                <td>
                                  {editingId === cls.ID ? (
                                    <input
                                      type="time"
                                      value={editForm.end}
                                      onChange={(e) =>
                                        setEditForm(prev => ({ ...prev, end: e.target.value }))
                                      }
                                    />
                                  ) : (
                                    cls.End_time
                                  )}
                                </td>
                                {/* RESCHEDULE DATE */}
                                <td>
                                  {editingId === cls.ID ? (
                                    <DatePicker withPortal
                                      selected={editForm.rescheduleDate}
                                      onChange={(date) =>
                                        setEditForm(prev => ({ ...prev, rescheduleDate: date }))
                                      }
                                      dateFormat="dd/MM/yyyy"
                                      placeholderText="Select Date"
                                      popperPlacement="bottom-start"
                                    />
                                  ) : (
                                    cls.RescheduleDate
                                  )}
                                </td>
                                <td>{cls.Status}</td>
                                <td className="flex gap-2">
                                    {editingId === cls.ID ? (
                                    <>
                                        <button onClick={() => handleSaveEdit(cls)} className="bg-green-500 text-white px-2 py-1 rounded">Save</button>
                                        <button onClick={() => setEditingId(null)} className="bg-gray-300 px-2 py-1 rounded">Cancel</button>
                                        {editConflictMessage && <span className="text-red-600">{editConflictMessage}</span>}
                                    </>
                                    ) : (
                                    <>
                                        <button onClick={() => {
                                          setEditingId(cls.ID);

                                          setEditForm({
                                            day: cls.Day,
                                            start: cls.Start_time,
                                            end: cls.End_time,
                                            classDate: parseDate(cls.ClassDate),
                                            rescheduleDate: cls.RescheduleDate ? parseDate(cls.RescheduleDate) : null,
                                          });

                                          setEditConflictMessage("");
                                        }} className="bg-yellow-500 text-white px-2 py-1 rounded">Edit</button>
                                        <button onClick={() => handleRemove(cls.ID)} className="bg-red-500 text-white px-2 py-1 rounded">Remove</button>
                                    </>
                                    )}
                                </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        ) : (
                        <p>No classes scheduled yet.</p>
                        )}
                    </div>
                    </td>
                </tr>
            </tbody>
          </table>
        </main>
      </section>
    </div>
  );
};

export default Scheduler;
